
import { Component, Input, Output, ViewChild, HostListener, EventEmitter } from '@angular/core';
import {ApiService} from '../services/api.service';
import {InternalService} from '../services/internal.service';


@Component({
  selector: 'app-nested-select',
  templateUrl: './nested-select.component.html',
  styleUrls: [ './nested-select.component.css' ]
})
export class NestedSelectComponent  {
  showDrp = false;
  @Input() searchKeyword = '';
  selectedOption = '';
  listData = [];
  filteredList = this.listData;
  @Input() title;

  @Input() set getListData(data: [any]) {
    this.listData = data || [];
    this.filteredList = this.listData;
  }
    constructor(public internalService: InternalService,
              public apiService: ApiService) {
  }

  @Input() set selectedValue(data) {
    this.selectedOption = data;
  }
  @Input() selectableParent = true;
  @Output() selectedValueChange = new EventEmitter();

  @ViewChild('insideElement') insideElement;
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const clickedInside = this.insideElement.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.showDrp = false;
    }
  }

  toggleItemList(e) {
    e.currentTarget.parentElement.parentElement.classList.toggle('collapsed-item')
  }

  setAsSelected(v, key, disabled = false, isParent) {
    this.internalService.isParent = isParent;
    if (isParent && !this.selectableParent) {
      return;
    }
    if (!disabled) {
      this.internalService.key = key;
      this.selectedValueChange.emit(v);
      this.showDrp = false;
    }
  }

  searchInList(v = '') {
   // console.log(v);
    this.filteredList = this.listData || [];
    if (v) {
      this.searchKeyword = v.trim();
      const listCopy = JSON.parse(JSON.stringify(this.filteredList));
      this.filteredList = this.filterOptions(listCopy);
    }
  }

  filterOptions(opt) {
    const result = [];
    opt.forEach( item => {
      const preventParent = !this.selectableParent && item['children'].length;
      const newChild = this.filterOptions(item['children'] || []);
      const passedTitleFilter = item.title.includes(this.searchKeyword) && !preventParent;
      // item['children'] = newChild;
      if (passedTitleFilter) {
        item['highlight-title'] = item.title.replace(this.searchKeyword, `<b>${this.searchKeyword}</b>`);
        result.push(item);
      } else if (newChild.length) {
        item['not--kw'] = true;
        result.push(item);
      } else {
        item['hidden--by--filter'] = true;
      }
    });
    return result;
  }
}
